module.exports = __webpack_public_path__ + "img/contacts.b7033c82.svg";